export const dictionaryListDrawerIdentifier = 'dictionaryList';
